import { Role, RoleDto } from '../../../modules/roles/roles/types/roles-page-types'

export const mapRoleDto = (role: RoleDto): Role => {
  return {
    ...role,
    permissions: role.permissions.reduce((acc: Record<number, boolean>, permission) => {
      acc[permission.id] = true

      return acc
    }, {}),
  }
}
